function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCurrentLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 11.7778C10.9818 11.7778 11.7778 10.9818 11.7778 10C11.7778 9.01816 10.9818 8.22222 10 8.22222C9.01816 8.22222 8.22222 9.01816 8.22222 10C8.22222 10.9818 9.01816 11.7778 10 11.7778Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2C10.4276 2 10.7742 2.34662 10.7742 2.77419V4.1146C13.4331 4.46095 15.5391 6.56695 15.8854 9.2258H17.2258C17.6534 9.2258 18 9.57242 18 10C18 10.4276 17.6534 10.7742 17.2258 10.7742H15.8854C15.5391 13.4331 13.4331 15.5391 10.7742 15.8855V17.2258C10.7742 17.6534 10.4276 18 10 18C9.57243 18 9.22581 17.6534 9.22581 17.2258V15.8855C6.5669 15.5391 4.46087 13.4331 4.11453 10.7742H2.77419C2.34662 10.7742 2 10.4276 2 10C2 9.57242 2.34662 9.2258 2.77419 9.2258H4.11455C4.46092 6.56694 6.56694 4.46094 9.22581 4.11459V2.77419C9.22581 2.34662 9.57243 2 10 2ZM10.7742 14.319V14.129C10.7742 13.7014 10.4276 13.3548 10 13.3548C9.57243 13.3548 9.22581 13.7014 9.22581 14.129V14.319C7.42341 13.9981 6.00188 12.5766 5.68098 10.7742H5.87097C6.29854 10.7742 6.64516 10.4276 6.64516 10C6.64516 9.57242 6.29854 9.2258 5.87097 9.2258H5.681C6.00193 7.42345 7.42344 6.00195 9.22581 5.68104V5.87097C9.22581 6.29854 9.57243 6.64516 10 6.64516C10.4276 6.64516 10.7742 6.29854 10.7742 5.87097V5.68105C12.5766 6.00196 13.9981 7.42345 14.319 9.2258H14.1291C13.7015 9.2258 13.3549 9.57242 13.3549 10C13.3549 10.4276 13.7015 10.7742 14.1291 10.7742H14.319C13.9981 12.5766 12.5766 13.9981 10.7742 14.319Z",
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCurrentLocation);
export default __webpack_public_path__ + "static/media/icon-current-location.959019f35ca8018bc338cfdf257bdde7.svg";
export { ForwardRef as ReactComponent };